<div class="loading-panel" *ngIf="(isLoading$ | async) === true" [@showHidePanel]>
  <div class='loading-spinner'>
    <i class="fa fa-spinner fa-spin"></i>
  </div>
</div>
